import z from 'zod'

import { zh } from '@/libs/utils/zod'

const PriceDto = z.object({
  mode: z.string(),
  price: z.number(),
})

type PriceDto = z.infer<typeof PriceDto>

const VariantDto = z.object({
  id: z.string(),
  name: z.string(),
  isDefault: z.boolean(),
  price: z.number(),
  prices: z.array(PriceDto),
})

type VariantDto = z.infer<typeof VariantDto>

const ProductDto = z.object({
  outletId: z.string(),
  name: z.string(),
  desc: z.string(),
  pricingBySalesMode: z.boolean(),
  hasVariant: z.boolean(),
  variants: z.array(VariantDto),
  price: z.number(),
  categoryId: z.string().nullable(),
  isActive: z.boolean(),
  recipeId: z.string().nullable(),
})

const ProductSelectDto = z.object({
  ...ProductDto.shape,
  ...zh.metadata.shape,
})

type ProductSelectDto = z.infer<typeof ProductSelectDto>

const ProductCreateBodyDto = z.object({
  ...ProductDto.omit({ variants: true }).shape,
  variants: z.array(
    z.object({
      ...VariantDto.omit({ id: true }).shape,
      id: z.string().nullable(),
    })
  ),
})

type ProductCreateBodyDto = z.infer<typeof ProductCreateBodyDto>

export { PriceDto, VariantDto, ProductSelectDto, ProductCreateBodyDto }
